import request from '../request';

/**
 * GET 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export const get = (url, params = {}) => {
  return request({
    method: 'get',
    url,
    params
  });
};

/**
 * POST 请求
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @returns {Promise}
 */
export const post = (url, data = {}) => {
  return request({
    method: 'post',
    url,
    data
  });
};

/**
 * PUT 请求
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @returns {Promise}
 */
export const put = (url, data = {}) => {
  return request({
    method: 'put',
    url,
    data
  });
};

/**
 * DELETE 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export const del = (url, params = {}) => {
  return request({
    method: 'delete',
    url,
    params
  });
};

const getSigndetail = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/sign/detail',
    data
  });
};
// 获取区县
const getAreaList = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/area',
    data
  });
};

// 获取人群列表
const getCrowdList = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/sign/crowd',
    data
  });
};
// 根据人群获取服务包
const getPackList = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/sign/packageByCrowdNo',
    data
  });
};
// 获取区县列表
const getCountyList = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/county',
    data
  });
};
// 根据区县获取机构列表
const getOrgList = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/orgByCounty',
    data
  });
};
// 获取机构列表
const getTeamList = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/teamByOrg',
    data
  });
};
// 获取医生列表
const getDoctorList = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/doctorByTeam',
    data
  });
};
// 签约保存
const saveSign = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/sign/save',
    data
  });
};
// 文件上传
const uploadFile = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/sign/residentSignatureUpload',
    data
  });
};
// 获取上传的文件
const getFile = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/sign/residentSignature',
    data
  });
};
// 获取用户实名信息
const getUserInfo = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/userinfo',
    data
  });
};
// 获取用户授权令牌
const getUserToken = (data = {}) => {
  return request({
    method: 'post',
    url: '/applet/aqfd/oauth',
    data
  });
};
/**
 * 默认导出所有方法
 */
export default {
  get,
  post,
  put,
  delete: del,
  getSigndetail,
  getAreaList,
  getCrowdList,
  getPackList,
  getOrgList,
  getCountyList,
  getTeamList,
  getDoctorList,
  saveSign,
  uploadFile,
  getFile,
  getUserInfo,
  getUserToken
};

